/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForExtendedResourceDiscovery extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForExtendedResourceDiscovery");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForExtendedResourceDiscovery.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForExtendedResourceDiscovery>): BackgroundJobPayloadForExtendedResourceDiscovery {
        let obj = Object.assign(new BackgroundJobPayloadForExtendedResourceDiscovery(), model);
        BackgroundJobPayloadForExtendedResourceDiscovery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForExtendedResourceDiscovery>): BackgroundJobPayloadForExtendedResourceDiscovery {
        if (!model) return null;
        return BackgroundJobPayloadForExtendedResourceDiscovery.newInstance(<BackgroundJobPayloadForExtendedResourceDiscovery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForExtendedResourceDiscovery) {
        if (!obj) return;

        models.BackgroundJobPayloadForExtendedResourceDiscovery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForExtendedResourceDiscovery): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForExtendedResourceDiscovery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    resource_inventory_id: string;

    extended_operation_details: { [key: string]: string; };

}
